"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("blueimp-canvas-to-blob");
var utils_1 = require("./utils");
var axios_1 = __importDefault(require("axios"));
// re-export utils
__export(require("./utils"));
var NyrisAPI = /** @class */ (function () {
    function NyrisAPI(settings) {
        this.httpClient = axios_1.default.create();
        if (!settings.apiKey) {
            throw new Error("The api-key is not set.");
        }
        this.apiKey = settings.apiKey;
        var baseUrl = settings.baseUrl || 'https://api.nyris.io';
        this.imageMatchingUrl = baseUrl + "/find/v1";
        this.cadMatchingUrl = baseUrl + "/cad/find/v0.1";
        this.imageMatchingUrlBySku = baseUrl + "/recommend/v1/";
        this.imageMatchingSubmitManualUrl = baseUrl + "/find/v1/manual/";
        this.feedbackUrl = baseUrl + "/feedback/v1/";
        this.regionProposalUrl = baseUrl + "/find/v1/regions/";
        this.responseFormat = settings.responseFormat || 'application/offers.nyris+json';
        this.maxHeight = settings.maxHeight || 500;
        this.maxWidth = settings.maxWidth || 500;
        this.jpegQuality = settings.jpegQuality || 0.92;
        this.customSearchRequest = settings.customSearchRequest;
        this.responseHook = settings.responseHook;
        this.xOptions = settings.xOptions;
    }
    NyrisAPI.prototype.prepareImage = function (canvas, cropRect) {
        return __awaiter(this, void 0, void 0, function () {
            var crop, originalSize, aspectRatio, scaledSize, resizedCroppedCanvas;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        crop = cropRect || {
                            x1: 0,
                            x2: 1,
                            y1: 0,
                            y2: 1
                        };
                        originalSize = utils_1.getElementSize(canvas);
                        aspectRatio = utils_1.getRectAspectRatio(crop, originalSize);
                        scaledSize = utils_1.getThumbSizeArea(this.maxWidth, this.maxHeight, aspectRatio);
                        resizedCroppedCanvas = utils_1.elementToCanvas(canvas, scaledSize, crop);
                        return [4 /*yield*/, utils_1.canvasToJpgBlob(resizedCroppedCanvas, this.jpegQuality)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    NyrisAPI.prototype.getSearchRequestHeaders = function (contentType) {
        // Create headers
        var headers = {
            'X-Api-Key': this.apiKey,
            'Accept-Language': 'de,*;q=0.5',
            'Accept': this.responseFormat,
            'Content-Type': contentType || 'application/octet-stream'
        };
        // Add options
        var xOptions = [];
        if (this.xOptions)
            xOptions.push(this.xOptions);
        if (xOptions.length > 0)
            headers['X-Options'] = xOptions.join(' ');
        return headers;
    };
    ;
    NyrisAPI.prototype.getRegionRequestHeaders = function (contentType) {
        // Create headers
        var headers = {
            'X-Api-Key': this.apiKey,
            'Content-Type': contentType || 'application/octet-stream'
        };
        // Add options
        var xOptions = [];
        if (this.xOptions)
            xOptions.push(this.xOptions);
        if (xOptions.length > 0)
            headers['X-Options'] = xOptions.join(' ');
        return headers;
    };
    ;
    NyrisAPI.prototype.getParams = function (options) {
        var params = options.geoLocation ? {
            lat: options.geoLocation.lat.toString(),
            lon: options.geoLocation.lon.toString(),
            dist: options.geoLocation.dist.toString()
        } : {};
        return params;
    };
    NyrisAPI.prototype.parseCategoryPredictions = function (categoryPredictionResponse) {
        return Object.entries(categoryPredictionResponse || {}).map(function (_a) {
            var name = _a[0], score = _a[1];
            return ({
                name: name,
                score: score
            });
        }).sort(function (a, b) { return b.score - a.score; });
    };
    NyrisAPI.prototype.parseSearchResult = function (res, durationSeconds) {
        var categoryPredictions = this.parseCategoryPredictions(res.data.predicted_category);
        var codes = res.data.barcodes || [];
        var responseData = this.responseHook ? this.responseHook(res.data) : res.data;
        var results = 'offerInfos' in responseData ?
            responseData.offerInfos.map(function (r, i) { return (__assign(__assign({}, r), { position: i })); })
            : responseData.results.map(function (r, i) {
                return ({
                    position: i,
                    sku: r.sku,
                    title: r.title,
                    img: r.images && r.images[0] ? { url: r.images[0] } : undefined,
                    l: r.links ? r.links.main : undefined,
                    p: r.price ? { vi: parseFloat(r.price) * 100, c: r.price.split(" ")[1] } : undefined
                });
            });
        var requestId = res.headers["x-matching-request"];
        var duration = 'durationSeconds' in res.data ? res.data.durationSeconds : durationSeconds;
        return { results: results, requestId: requestId, duration: duration, categoryPredictions: categoryPredictions, codes: codes };
    };
    /**
     * Search using the experimental CAD API
     * @param file - A CAD file
     * @param options - Image search options
     * @deprecated This is a prototype API and might be removed/changed at any time.
     */
    NyrisAPI.prototype.findByCad = function (file, options) {
        return __awaiter(this, void 0, void 0, function () {
            var fileType, headers, params, _a, res, durationSeconds;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        fileType = file.type;
                        headers = this.getSearchRequestHeaders(fileType);
                        params = this.getParams(options);
                        return [4 /*yield*/, utils_1.timePromise(this.httpClient.request({
                                method: 'POST',
                                url: this.cadMatchingUrl,
                                data: file,
                                params: params,
                                headers: headers,
                                responseType: 'json'
                            }))];
                    case 1:
                        _a = _b.sent(), res = _a.res, durationSeconds = _a.durationSeconds;
                        return [2 /*return*/, this.parseSearchResult(res, durationSeconds)];
                }
            });
        });
    };
    /**
     * Search for an image.
     * @param canvas Image, Video (frame) or Canvas to use use for image search.
     * @param options See [[ImageSearchOptions]].
     */
    NyrisAPI.prototype.findByImage = function (canvas, options) {
        return __awaiter(this, void 0, void 0, function () {
            var imageBytes, headers, params, _a, res, durationSeconds;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.prepareImage(canvas, options.cropRect)];
                    case 1:
                        imageBytes = _b.sent();
                        if (this.customSearchRequest)
                            return [2 /*return*/, this.customSearchRequest(imageBytes, this.httpClient)];
                        headers = this.getSearchRequestHeaders('image/jpeg');
                        params = this.getParams(options);
                        return [4 /*yield*/, utils_1.timePromise(this.httpClient.request({
                                method: 'POST',
                                url: this.imageMatchingUrl,
                                data: imageBytes,
                                params: params,
                                headers: headers,
                                responseType: 'json'
                            }))];
                    case 2:
                        _a = _b.sent(), res = _a.res, durationSeconds = _a.durationSeconds;
                        return [2 /*return*/, this.parseSearchResult(res, durationSeconds)];
                }
            });
        });
    };
    /**
     * Search by SKU (itemID)
     * @param sku The SKU or ID of the item.
     * @param mid The index ID.
     */
    NyrisAPI.prototype.findBySku = function (sku, mid) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, url, r;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers = this.getSearchRequestHeaders();
                        url = "" + this.imageMatchingUrlBySku + encodeURIComponent(sku) + "/" + encodeURIComponent(mid);
                        return [4 /*yield*/, this.httpClient.get(url, { headers: headers, responseType: 'json' })];
                    case 1:
                        r = _a.sent();
                        if (this.responseHook) {
                            r = this.responseHook;
                        }
                        return [2 /*return*/, r];
                }
            });
        });
    };
    /**
     * Find significant sections in the image.
     * @param canvas Canvas, video or image to search with.
     * @returns A list of regions, see [[Region]].
     */
    NyrisAPI.prototype.findRegions = function (canvas) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, origW, origH, scaledSize, resizedCroppedCanvas, blob, headers, response, regions;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = utils_1.getElementSize(canvas), origW = _a.w, origH = _a.h;
                        scaledSize = utils_1.getThumbSizeArea(this.maxWidth, this.maxHeight, origW / origH);
                        resizedCroppedCanvas = utils_1.elementToCanvas(canvas, scaledSize);
                        return [4 /*yield*/, utils_1.canvasToJpgBlob(resizedCroppedCanvas, this.jpegQuality)];
                    case 1:
                        blob = _b.sent();
                        headers = this.getRegionRequestHeaders('image/jpeg');
                        return [4 /*yield*/, this.httpClient.request({
                                method: 'POST',
                                url: this.regionProposalUrl,
                                data: blob,
                                headers: headers
                            })];
                    case 2:
                        response = _b.sent();
                        regions = response.data;
                        return [2 /*return*/, regions.map(function (r) { return ({
                                className: r.className,
                                confidence: r.confidence,
                                normalizedRect: {
                                    x1: r.region.left / scaledSize.w,
                                    x2: (r.region.right / scaledSize.w),
                                    y1: r.region.top / scaledSize.h,
                                    y2: (r.region.bottom / scaledSize.h),
                                }
                            }); })];
                }
            });
        });
    };
    /**
     * Send feedback event.
     * @param sessionId ID of the session. Usually the first request ID returned.
     * @param requestId The request ID to submit the feedback event to.
     * @param payload See [[FeedbackEventPayload]].
     */
    NyrisAPI.prototype.sendFeedback = function (sessionId, requestId, payload) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers = {
                            'X-Api-Key': this.apiKey,
                            'Content-Type': 'application/json'
                        };
                        data = __assign({ request_id: requestId, timestamp: new Date(), session_id: sessionId }, payload);
                        return [4 /*yield*/, this.httpClient.request({
                                method: 'POST',
                                url: this.feedbackUrl,
                                headers: headers,
                                data: data
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return NyrisAPI;
}());
exports.default = NyrisAPI;
//# sourceMappingURL=index.js.map